import { render, staticRenderFns } from "./MleHarmonizedCodeSummary.vue?vue&type=template&id=20881e33"
import script from "./MleHarmonizedCodeSummary.ts?vue&type=script&lang=ts&external"
export * from "./MleHarmonizedCodeSummary.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports